import {Injectable} from '@angular/core';

import {CanLeavePage} from '../models/can-leave-page';

@Injectable({
    providedIn: 'root',
})
export class PageLeaveGuard  {

    canDeactivate(component: CanLeavePage): Promise<boolean> {
        return component.canLeave();
    }

}
